import type { Locale, MessageKey } from './i18n/messages.js';
import { messages } from './i18n/messages.js';

const LOCALE_KEY = 'hg_locale';

type Listener = () => void;

class AppStore {
  locale: Locale = 'en';
  drawerOpen = false;
  private listeners = new Set<Listener>();

  constructor() {
    const saved = localStorage.getItem(LOCALE_KEY);
    if (saved === 'en' || saved === 'fr' || saved === 'bm') this.locale = saved;
    document.documentElement.lang = this.locale;
  }

  t(key: MessageKey): string {
    return messages[this.locale][key] ?? messages.en[key];
  }

  subscribe(fn: Listener) {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  private emit() {
    for (const fn of this.listeners) fn();
  }

  setLocale(locale: Locale) {
    this.locale = locale;
    localStorage.setItem(LOCALE_KEY, locale);
    document.documentElement.lang = locale;
    this.emit();
  }

  setDrawer(open: boolean) {
    this.drawerOpen = open;
    document.body.style.overflow = open ? 'hidden' : '';
    this.emit();
  }

  navigated() {
    this.emit();
  }
}

export const store = new AppStore();
